/**
 * Include your custom JavaScript here.
 */

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  window.onscroll = function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
        btn = document.getElementById('scrollToTop');
    if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }
}

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}

$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

// ===== 3x SEM JUROS — badge no produto =====
(function() {
  var BADGE_HTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="height:15px;margin-right:3px"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg><b>3x sem juros</b> no cartão';
  function insertBadge() {
    if (document.querySelector('.badge-sem-juros-femeluz')) return true;
    var anchor = document.querySelector('[popup-open="popup-1"]');
    if (!anchor) anchor = document.querySelector('.kassxi[popup-open]');
    if (!anchor) return false;
    var badge = document.createElement('span');
    badge.className = 'badge-sem-juros-femeluz';
    badge.style.cssText = 'display:inline-flex;align-items:center;gap:4px;margin-bottom:6px;padding:4px 10px;border-radius:21px;color:#16a34a;font-size:12px;border:1px solid #16a34a;cursor:default;';
    badge.innerHTML = BADGE_HTML;
    anchor.parentNode.insertBefore(badge, anchor);
    return true;
  }
  var tries = 0;
  var iv = setInterval(function() {
    tries++;
    insertBadge();
    if (tries >= 20) clearInterval(iv);
  }, 300);
})();

// ===== CORRIGIR ESTRELAS DO RESUMO (ezdrop-stars-summary) =====
(function() {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var FULL_COLOR = 'rgb(255, 207, 100)';
  var EMPTY_COLOR = '#d0d0d0';

  function applyPartialStar(svgEl, pct) {
    var polygon = svgEl.querySelector('polygon');
    if (!polygon) return;
    var gradId = 'fml-star-grad-' + Math.random().toString(36).slice(2);
    var defs = document.createElementNS(SVG_NS, 'defs');
    var grad = document.createElementNS(SVG_NS, 'linearGradient');
    grad.setAttribute('id', gradId);
    grad.setAttribute('x1', '0%'); grad.setAttribute('x2', '100%');
    grad.setAttribute('y1', '0%'); grad.setAttribute('y2', '0%');
    var s1 = document.createElementNS(SVG_NS, 'stop');
    s1.setAttribute('offset', (pct * 100).toFixed(1) + '%');
    s1.setAttribute('stop-color', FULL_COLOR);
    var s2 = document.createElementNS(SVG_NS, 'stop');
    s2.setAttribute('offset', (pct * 100).toFixed(1) + '%');
    s2.setAttribute('stop-color', EMPTY_COLOR);
    grad.appendChild(s1); grad.appendChild(s2);
    defs.appendChild(grad);
    svgEl.insertBefore(defs, svgEl.firstChild);
    polygon.setAttribute('fill', 'url(#' + gradId + ')');
  }

  function fixSummaryStars() {
    var summaryEl = document.querySelector('.ezdrop-stars-summary');
    var avgEl = document.querySelector('.review-resume-number');
    if (!summaryEl || !avgEl) return false;
    var avgText = avgEl.textContent.match(/[\d.]+/);
    if (!avgText) return false;
    var avg = parseFloat(avgText[0]);
    if (isNaN(avg) || avg <= 0) return false;
    var stars = Array.from(summaryEl.querySelectorAll('svg'));
    if (stars.length !== 5) return false;
    if (summaryEl.getAttribute('data-rating-fixed') === String(avg)) return true;
    stars.forEach(function(svg, i) {
      var polygon = svg.querySelector('polygon');
      if (!polygon) return;
      var starNum = i + 1;
      if (starNum <= Math.floor(avg)) {
        polygon.setAttribute('fill', FULL_COLOR);
      } else if (starNum === Math.ceil(avg)) {
        var frac = avg - Math.floor(avg);
        if (frac === 0) polygon.setAttribute('fill', FULL_COLOR);
        else applyPartialStar(svg, frac);
      } else {
        polygon.setAttribute('fill', EMPTY_COLOR);
      }
    });
    summaryEl.setAttribute('data-rating-fixed', String(avg));
    return true;
  }

  if (!fixSummaryStars()) {
    var observer = new MutationObserver(function() {
      if (fixSummaryStars()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 30000);
  }
})();
